import { render } from "./Frame.vue?vue&type=template&id=cec15798&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"

import "./Frame.vue?vue&type=style&index=0&id=cec15798&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec15798"]])

export default __exports__